<template>
  <span class="run-number">
    <span class="run-number__eyebrow">Run</span>
    <span class="run-number__value">{{ value }}</span>
  </span>
</template>

<script setup>
// The lot's run number, the console's largest single piece of identity.
//
// It took the whole item record to read one field. It takes the field.
defineOptions({ name: 'RunNumber' });

defineProps({
  value: { type: [String, Number], required: true },
});
</script>

<style scoped>
.run-number {
  display: inline-flex;
  align-items: baseline;
  gap: var(--p-run-number-gap);
  color: var(--p-run-number-color);
}

.run-number__eyebrow {
  font-size: var(--p-run-number-eyebrow-font-size);
  font-weight: var(--p-run-number-eyebrow-font-weight);
  letter-spacing: var(--p-run-number-eyebrow-letter-spacing);
  color: var(--p-run-number-eyebrow-color);
  text-transform: uppercase;
}

.run-number__value {
  font-family: var(--p-run-number-value-font-family);
  font-weight: var(--p-run-number-value-font-weight);
  font-size: var(--p-run-number-value-font-size);
  letter-spacing: var(--p-run-number-value-letter-spacing);
  line-height: var(--p-run-number-value-line-height);
  color: var(--p-run-number-value-color);
  font-variant-numeric: tabular-nums;
}
</style>
